document.addEventListener('DOMContentLoaded', function() {
  const wrapper = document.querySelector('.brands-map-wrapper');
  const drawerClose = document.querySelector('.brands-drawer-close');
  const drawerInner = document.querySelector('.brands-drawer-inner');
  const drawerLogo = document.getElementById('drawer-logo');
  const drawerBody = document.getElementById('drawer-body');
  const drawerLink = document.getElementById('drawer-link');
  const drawerProductsList = document.getElementById('drawer-products-list');
  const mapPins = document.querySelectorAll('.map-pin-interactive');
  const prevBtn = document.querySelector('.slider-btn-prev');
  const nextBtn = document.querySelector('.slider-btn-next');
  
  let currentSlide = 0;
  let totalProducts = 0;
  const productsCache = {};

  // Function to fetch collection products
  async function fetchCollectionProducts(collectionHandle) {
    try {
      const response = await fetch(`/collections/${collectionHandle}/products.json?limit=12`);
      const data = await response.json();
      return data.products;
    } catch (error) {
      console.error('Error fetching products:', error);
      return [];
    }
  }

  // Function to render products
  function renderProducts(products) {
    if (!products || products.length === 0) {
      drawerProductsList.innerHTML = '<p style="padding: 1rem; text-align: center; color: #999;">No products found</p>';
      prevBtn.disabled = true;
      nextBtn.disabled = true;
      return;
    }

    totalProducts = products.length;
    currentSlide = 0;

    const productsHTML = products.map(product => {
      const imageUrl = product.images[0] ? product.images[0].src : '';
      const rawPrice = product.variants[0].price;
      const formattedPrice = window.shopCurrency 
        ? window.shopCurrency.moneyFormat.replace(/{{\s*amount[^}]*}}/g, rawPrice)
        : rawPrice;
      
      return `
        <a href="/products/${product.handle}" class="product-card">
          <img src="${imageUrl}" alt="${product.title}" class="product-card-image" loading="lazy">
          <h4 class="product-card-title">${product.title}</h4>
          <p class="product-card-price">${formattedPrice}</p>
        </a>
      `;
    }).join('');

    drawerProductsList.innerHTML = productsHTML;
    updateSliderButtons();
  }

  // Slider navigation
  function updateSliderButtons() {
    prevBtn.disabled = currentSlide === 0;
    nextBtn.disabled = currentSlide >= totalProducts - 1;
  }

  function slideProducts(direction) {
    const firstCard = drawerProductsList.querySelector('.product-card');
    if (!firstCard) return;
    const style = window.getComputedStyle(drawerProductsList);
    const gap = parseFloat(style.gap) || 16;
    const cardWidth = firstCard.offsetWidth + gap;
    if (direction === 'next' && currentSlide < totalProducts - 1) {
      currentSlide++;
    } else if (direction === 'prev' && currentSlide > 0) {
      currentSlide--;
    }
    drawerProductsList.style.transform = `translateX(-${currentSlide * cardWidth}px)`;
    updateSliderButtons();
  }

  prevBtn.addEventListener('click', () => slideProducts('prev'));
  nextBtn.addEventListener('click', () => slideProducts('next'));

  // Preload all collection products on page load
  async function preloadAllProducts() {
    const handles = [];
    mapPins.forEach(function(pin) {
      const handle = pin.getAttribute('data-collection-handle');
      if (handle && handle !== 'null' && handle !== '' && !handles.includes(handle)) {
        handles.push(handle);
      }
    });

    await Promise.all(handles.map(async (handle) => {
      productsCache[handle] = await fetchCollectionProducts(handle);
    }));
  }

  // Start preloading products immediately
  preloadAllProducts();

  // Function to update drawer content
  function updateDrawerContent(collectionTitle, collectionUrl, collectionImage, collectionDescription, collectionHandle) {
    // Set logo
    if (collectionImage && collectionImage !== 'null' && collectionImage !== '') {
      drawerLogo.innerHTML = '<img src="' + collectionImage + '" alt="' + collectionTitle + ' logo">';
    } else {
      drawerLogo.innerHTML = '';
    }

    // Set description
    if (collectionDescription && collectionDescription !== 'null' && collectionDescription !== '') {
      const truncatedDescription = collectionDescription.length > 150 
        ? collectionDescription.substring(0, 150) + '...' 
        : collectionDescription;
      drawerBody.innerHTML = '<p>' + truncatedDescription + '</p>';
    } else {
      drawerBody.innerHTML = '<p>Explore our ' + collectionTitle + ' collection.</p>';
    }
    
    // Set link
    drawerLink.href = collectionUrl;
    
    // Render products from cache
    if (collectionHandle && collectionHandle !== 'null' && collectionHandle !== '') {
      const products = productsCache[collectionHandle] || [];
      renderProducts(products);
    }
  }

  // Function to open drawer
  function openDrawer(collectionTitle, collectionUrl, collectionImage, collectionDescription, collectionHandle) {
    if (collectionTitle && collectionUrl) {
      const isAlreadyOpen = wrapper.classList.contains('drawer-active');
      
      if (isAlreadyOpen) {
        // Fade out, update content, fade back in
        drawerInner.classList.add('fade-out');
        setTimeout(() => {
          updateDrawerContent(collectionTitle, collectionUrl, collectionImage, collectionDescription, collectionHandle);
          drawerInner.classList.remove('fade-out');
        }, 200);
      } else {
        // First open - update content and open drawer
        updateDrawerContent(collectionTitle, collectionUrl, collectionImage, collectionDescription, collectionHandle);
        wrapper.classList.add('drawer-active');
      }

      // Smooth scroll to the top of the map, accounting for header height
      const header = document.querySelector('header') || document.querySelector('.header');
      const headerHeight = header ? header.offsetHeight : 0;
      const mapTop = wrapper.getBoundingClientRect().top + window.pageYOffset - headerHeight;
      window.scrollTo({ top: mapTop, behavior: 'smooth' });
    }
  }

  // Function to close drawer
  function closeDrawer() {
    wrapper.classList.remove('drawer-active');
    currentSlide = 0;
    drawerProductsList.style.transform = 'translateX(0)';
  }

  // Add click event to each map pin
  mapPins.forEach(function(pin) {
    pin.addEventListener('click', function() {
      const title = this.getAttribute('data-collection-title');
      const url = this.getAttribute('data-collection-url');
      const image = this.getAttribute('data-collection-image');
      const description = this.getAttribute('data-collection-description');
      const handle = this.getAttribute('data-collection-handle');
      openDrawer(title, url, image, description, handle);
    });
  });

  // Close drawer on close button click
  drawerClose.addEventListener('click', closeDrawer);

  // Close drawer on ESC key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && wrapper.classList.contains('drawer-active')) {
      closeDrawer();
    }
  });
});
